import { render, staticRenderFns } from "./ninfruit.vue?vue&type=template&id=4ca026d7"
import script from "./ninfruit.vue?vue&type=script&lang=js"
export * from "./ninfruit.vue?vue&type=script&lang=js"
import style0 from "./ninfruit.vue?vue&type=style&index=0&id=4ca026d7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports